'use strict'

SaveTaxonomyPreferencesModel = require '../model/save_taxonomy_preferences'

module.exports =
  createTaxonomyPreferencesModel: (cookieExists, showTaxonomyPreferences) ->
    return if cookieExists
    if showTaxonomyPreferences == true
      return new SaveTaxonomyPreferencesModel()
